// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"d47b6495","458":"bb838eff"}[chunkId] + ".chunk.css";
};